import Axios from 'axios';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
import OverviewpageItem from '@/components/overview/overviewpage.item.vue';

gsap.registerPlugin(ScrollToPlugin);

const overview = {
    components: {
        OverviewpageItem
    },
    data: function() {
        return {
            searchResults: [],
            emptyResult: false,
            resultsCount: null,
            currentPage: 1,
            loading: true,
            searchQuery: '',
            wait: 500,
            elapsed: 0,
            loadItems: 12
        };
    },
    props: {
        pageId: {
            type: String,
            default: null
        }
    },

    watch: {
        currentPage: function() {
            this.currentPageWatcher();
        },
        searchQuery: function() {
            if (this.elapsed != 0) {
                clearInterval(this.elapsed);
            }
            this.elapsed = setInterval(this.getItems, this.wait);
            this.currentPage = 1;
            this.emptyResult = false;
        }
    },

    computed: {
        pages: function() {
            if (this.resultsCount % 12 == 0) {
                return this.resultsCount / 12;
            }
            return Math.ceil(this.resultsCount / 12);
        },

        currentPageId: function() {
            if (this.pageId != null) {
                return '&pageId=' + this.pageId;
            }
        }
    },

    methods: {
        getItems: function() {
            clearInterval(this.elapsed);
            this.loading = true;
            this.searchResults = [];
            const getUrl =
                '/umbraco/api/search/getOverviewContent?q=' +
                this.searchQuery +
                '&page=' +
                this.currentPage +
                this.currentPageId +
                '&itemsPerPage=' +
                this.loadItems +
                '&v=' +
                Date.now();
            Axios.get(getUrl).then(response => {
                if (response.status == 200 && response.data.data) {
                    this.searchResults = response.data.data;
                    this.resultsCount = response.data.results;
                    this.emptyResult =
                        response.data.results != 0 ? false : true;
                }
                this.loading = false;
                gsap.to(window, 1, {
                    scrollTo: { y: 0, autoKill: true },
                    delay: 0,
                    ease: 'cubic.easeOut'
                });
            });
        },

        trySubtractFive: function() {
            if (this.currentPage > 5) {
                this.currentPage = this.currentPage - 5;
            } else {
                this.currentPage = 1;
            }
        },

        tryAddFive: function() {
            if (this.currentPage < this.pages - 5) {
                this.currentPage = this.currentPage + 5;
            } else {
                this.currentPage = this.pages;
            }
        },

        currentPageWatcher: function() {
            this.getItems();
        }
    },

    mounted() {
        this.getItems();
    }
};

export default overview;
